// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import AudioViewer from '@/views/files/handler/viewer/AudioViewer.vue';
import FileViewer from '@/views/files/handler/viewer/FileViewer.vue';
import FileViewerWrapper from '@/views/files/handler/viewer/FileViewerWrapper.vue';
import ImageViewer from '@/views/files/handler/viewer/ImageViewer.vue';
import PdfViewer from '@/views/files/handler/viewer/PdfViewer.vue';
import TextViewer from '@/views/files/handler/viewer/TextViewer.vue';
import VideoViewer from '@/views/files/handler/viewer/VideoViewer.vue';

export { AudioViewer, FileViewer, FileViewerWrapper, ImageViewer, PdfViewer, TextViewer, VideoViewer };
